"use strict";

var _regeneratorRuntime = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/regenerator/index.js");

var _toConsumableArray = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addItemToCart = exports.mapToShortenedKeys = void 0;

var frontend_common_1 = require("@ryerson/frontend.common");

var frontend_common_2 = require("@ryerson/frontend.common");
/*
    We are using abbreviation when Item gets added to cookies/Local storage.
    Here is the list of abbreviation defined for add item to cart.
    https://ryerson.atlassian.net/wiki/spaces/WD/pages/2196832322/Abbreviation+used+for+Add+item+to+Cart+Cookies
*/


var mapToShortenedKeys = function mapToShortenedKeys(item) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;

  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
    mm: item.ryersonSku,
    qty: item.quantity,
    quom: item.quantityUom,
    puom: item.pricingUom
  }, item.customerRefNumber && {
    crn: item.customerRefNumber
  }), item.notes && {
    note: item.notes
  }), item.purchaseOrderNumber && {
    po: item.purchaseOrderNumber
  }), item.domesticRequired && {
    domestic: item.domesticRequired
  }), item.requestedDeliveryDate && {
    rdd: item.requestedDeliveryDate
  }), item.processing && {
    process: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, ((_a = item.processing) === null || _a === void 0 ? void 0 : _a.process) && {
      proc: item.processing.process
    }), ((_b = item.processing) === null || _b === void 0 ? void 0 : _b.finish) && {
      fnsh: item.processing.finish
    }), ((_c = item.processing) === null || _c === void 0 ? void 0 : _c.shape) && {
      shp: item.processing.shape
    }), ((_d = item.processing) === null || _d === void 0 ? void 0 : _d.length) && {
      len: item.processing.length
    }), ((_e = item.processing) === null || _e === void 0 ? void 0 : _e.width) && {
      wid: item.processing.width
    }), ((_f = item.processing) === null || _f === void 0 ? void 0 : _f.outsideDiameter) && {
      outsdDia: item.processing.outsideDiameter
    }), ((_g = item.processing) === null || _g === void 0 ? void 0 : _g.insideDiameter) && {
      insdDia: item.processing.insideDiameter
    }), ((_h = item.processing) === null || _h === void 0 ? void 0 : _h.toleranceMin) && {
      tolMin: item.processing.toleranceMin
    }), ((_j = item.processing) === null || _j === void 0 ? void 0 : _j.toleranceMax) && {
      tolMax: item.processing.toleranceMax
    }), ((_k = item.processing) === null || _k === void 0 ? void 0 : _k.toleranceMinInsideDiameter) && {
      tolMinInsdDia: item.processing.toleranceMinInsideDiameter
    }), ((_l = item.processing) === null || _l === void 0 ? void 0 : _l.toleranceMaxInsideDiameter) && {
      tolMaxInsdDia: item.processing.toleranceMaxInsideDiameter
    })
  });
};

exports.mapToShortenedKeys = mapToShortenedKeys;

var addItemToCart = function addItemToCart(axiosInstance, isLoggedIn, items) {
  var onFinish = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};
  var onFailure = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {};
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var currentCartData, newCartData;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!isLoggedIn) {
              _context.next = 5;
              break;
            }

            _context.next = 3;
            return axiosInstance.post("".concat(frontend_common_1.ApiUrl.ADD_TO_CART), items).then(function (response) {
              if ((0, frontend_common_2.isAxiosError)(response)) {
                throw response;
              }

              onFinish(response);
            }).catch(onFailure);

          case 3:
            _context.next = 10;
            break;

          case 5:
            currentCartData = JSON.parse((0, frontend_common_1.getLocalStorageItem)(frontend_common_1.LocalItems.addToCart, []));
            currentCartData = [].concat(_toConsumableArray(currentCartData), _toConsumableArray(items.map(exports.mapToShortenedKeys)));
            (0, frontend_common_1.setLocalStorageItem)(frontend_common_1.LocalItems.addToCart, currentCartData);
            newCartData = JSON.parse((0, frontend_common_1.getLocalStorageItem)(frontend_common_1.LocalItems.addToCart, []));

            if (newCartData.length === currentCartData.length) {
              onFinish(newCartData);
            } else {
              onFailure();
            }

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};

exports.addItemToCart = addItemToCart;